<template>
  <div v-if="internalValue" id="applicant-edit-tab-personal-data">
    <div>
      <div id="jobAllgemein" class="flex flex-wrap flex-row">
        <DataInput
          v-model="internalValue.title"
          required
          class="w-full md:w-5/6 md:mt-4 p-3"
          label="Titel"
          name="title"
          validation-rules="required"
          @input="setVamTitle"
        />

        <DataInput
          v-model="internalValue.active"
          type="bool"
          class="w-full md:w-1/6 md:mt-4 p-3"
          label="Aktiv"
          name="active"
        />
      </div>
      <div id="jobEinstellungen" class="flex flex-wrap flex-row">
        <h4 class="w-full mt-4 md:mt-12 p-3">Stellen Einstellungen</h4>

        <DataInput
          v-model="internalValue.recruitment"
          type="bool"
          class="w-1/2 md:w-1/3 md:mt-4 p-3"
          label="Personalvermittlung"
          name="recruitment"
        />

        <DataInput
          v-model="internalValue.takeoverOption"
          type="bool"
          class="w-1/2 md:w-1/3 md:mt-4 p-3"
          label="Übernahmeoption"
          name="takeoverOption"
        />

        <DataInput
          v-model="internalValue.holidayAndChristmasBonus"
          type="bool"
          class="w-full md:w-1/3 md:mt-4 p-3"
          label="Urlaubs- & Weihnachtsgeld"
          name="holidayAndChristmasBonus"
        />

        <DataInput
          v-model="internalValue.workPlace"
          class="w-full md:w-1/2 lg:w-1/4 md:mt-4 p-3"
          label="Arbeitsort"
          name="workPlace"
        />

        <DataInput
          v-model="internalValue.jobEarningLegacy"
          class="w-full md:w-1/2 lg:w-1/4 md:mt-4 p-3"
          label="Verdienst"
          name="jobEarningLegacy"
        />

        <DataInput
          v-model="internalValue.jobHoursLegacy"
          class="w-full md:w-1/2 lg:w-1/4 md:mt-4 p-3"
          label="Wochenarbeitszeit"
          name="jobHoursLegacy"
        />

        <DataInput
          v-model="internalValue.occupationCategory"
          type="model"
          class="w-full md:w-1/2 lg:w-1/4 md:mt-4 p-3"
          label="Kategorie"
          name="occupationCategory"
          gql-query="occupationCategories"
          nullable
        />

        <DataInput
          v-model="internalValue.jobType"
          type="model"
          class="w-full md:w-1/2 lg:w-1/4 md:mt-4 p-3"
          label="Jobtyp"
          name="jobType"
          gql-query="vacancyJobTypes"
        />

        <DataInput
          v-model="internalValue.jobTemplateID"
          type="model"
          class="w-full md:w-1/2 lg:w-1/4 md:mt-4 p-3"
          label="Job Variante"
          name="vacancyTemplateType"
          gql-query="vacancyTemplateTypes"
        />

        <DataInput
          v-model="internalValue.jobTimes"
          type="model"
          class="w-full md:w-1/2 lg:w-1/4 md:mt-4 p-3"
          label="Arbeitszeiten"
          name="jobTimes"
          gql-query="vacancyJobTimes"
        />

        <DataInput
          v-model="internalValue.occupationBenefitID"
          :initial-value="internalValue.occupationBenefit"
          type="model"
          class="w-full md:w-1/2 lg:w-1/4 md:mt-4 p-3"
          label="Benefits"
          name="occupationBenefit"
          gql-query="occupationBenefits"
        />
      </div>

      <div class="mx-2">
        <DataInput
          v-model="internalValue.address"
          type="address"
          required
          street-not-required
          validation-rules="required"
          class="w-full"
          label="Adresse"
          name="address"
        />
      </div>
      <div id="website" class="flex flex-wrap flex-row">
        <h4 class="w-full mt-4 md:mt-12 p-3">Export Webseite</h4>

        <div id="website" class="flex flex-wrap flex-row w-full">
          <DataInput
            v-model="internalValue.allowOnlineApplication"
            type="bool"
            class="w-full md:w-1/3 md:mt-4 p-3"
            label="Aktiviert auf Homepage"
            name="allowOnlineApplication"
          />
        </div>

        <DataInput
          v-if="internalValue.allowOnlineApplication"
          v-model="internalValue.topjob"
          type="bool"
          class="w-1/3 md:mt-4 p-3"
          label="Top Job"
          name="topjob"
        />

        <DataInput
          v-if="internalValue.topjob"
          v-model="internalValue.topjobDate"
          type="date"
          class="w-2/3 md:mt-4 p-3"
          label="Top-Job veröffentlicht am"
          name="topjobDate"
        />
      </div>
      <div
        v-if="$store.getters['user/hasPermission']('vacancy_republish')"
        id="publish"
        class="flex flex-wrap flex-row"
      >
        <h4 class="w-full mt-4 md:mt-12 p-3">Veröffentlichung</h4>

        <DataInput
          v-model="republish"
          type="bool"
          class="w-full md:w-1/6 md:mt-4 p-3"
          label="Wiederveröffentlichen"
          name="republish"
        />
      </div>

      <div v-if="!republish" class="flex flex-wrap flex-row">
        <DataInput
          v-model="internalValue.activeFrom"
          type="date"
          class="w-1/2 md:w-1/3 md:mt-4 p-3"
          label="Aktiv ab"
          name="activeFrom"
          :disabled="!activeFromEditable"
          :validation-rules="
            internalValue.allowOnlineApplication || internalValue.vamExport
              ? 'required'
              : ''
          "
        />

        <DataInput
          v-model="internalValue.activeUntil"
          type="date"
          class="w-1/2 md:w-1/3 md:mt-4 p-3"
          label="Aktiv bis"
          name="activeUntil"
          :validation-rules="
            internalValue.allowOnlineApplication || internalValue.vamExport
              ? 'required'
              : ''
          "
        />
      </div>
      <div v-else>
        <DataInput
          v-if="activeFromEditable"
          v-model="internalValue.activeFrom"
          type="date"
          class="w-1/2 md:w-1/3 md:mt-4 p-3"
          label="Aktiv ab"
          name="activeFrom"
          required
          :disabled="!activeFromEditable"
          :validation-rules="
            internalValue.allowOnlineApplication || internalValue.vamExport
              ? 'required'
              : ''
          "
        />
        <DataInput
          v-else
          :value="
            internalValue.publication.rePublishFrom || internalValue.activeFrom
          "
          type="date"
          class="w-1/2 md:w-1/3 md:mt-4 p-3"
          label="Aktiv ab"
          disabled
        />

        <DataInput
          v-model="internalValue.publication.rePublishUntil"
          type="date"
          class="w-1/2 md:w-1/3 md:mt-4 p-3"
          label="Aktiv bis"
          name="rePublishUntil"
        />

        <DataInput
          v-model="internalValue.publication.rePublishAmount"
          type="number"
          class="w-1/2 md:w-1/3 md:mt-4 p-3"
          label="Anzahl Wiederveröffentlichungen"
          name="rePublishAmount"
        />

        <DataInput
          v-model="internalValue.publication.rePublishInterval"
          type="number"
          class="w-1/2 md:w-1/3 md:mt-4 p-3"
          label="Wiederveröffentlichung nach Tagen"
          name="rePublishInterval"
        />
      </div>
      <div class="flex flex-wrap flex-row w-full">
        <h4 class="w-full mt-4 md:mt-12 p-3">Export Arbeitsagentur</h4>
        <DataInput
          v-model="internalValue.vamExport"
          type="bool"
          class="w-full md:w-1/3 md:mt-4 p-3"
          label="Export zu Arbeitsagentur"
          name="vamExport"
          @input="setVamTitle"
        />

        <div
          v-if="internalValue.vamExport"
          class="w-full md:w-2/3 md:mt-4 p-3"
          :class="{ titleLong: vamTitleError == true }"
        >
          <DataInput
            v-model="internalValue.vamTitle"
            label="BA Titel"
            name="vamTitle"
            validation-rules="max:54"
            @input="checkVamTitle"
          />
          <span v-if="vamTitleError == true">Titel zu lang für BA-Export</span>
        </div>

        <DataInput
          v-if="internalValue.vamExport"
          v-model="internalValue.vamJobOfferType"
          :required="!!internalValue.vamExport"
          type="select"
          :options="BAJobOfferType"
          options-type="number"
          validation-rules="required"
          class="w-full md:w-1/3 md:mt-4 p-3"
          label="Jobangebot Typ"
          name="vamJobOfferType"
        />

        <DataInput
          v-if="internalValue.vamJobOfferType && internalValue.vamExport"
          v-model="internalValue.vamOccupationID"
          :required="!!internalValue.vamExport"
          :initial-value="internalValue.vamOccupation"
          validation-rules="required"
          type="model"
          class="w-full md:w-1/3 md:mt-4 p-3"
          label="Jobbezeichnung Arbeitsagentur"
          name="vamExport"
          gql-query="bAOccupations"
          :gql-query-attributes="
            `page: 1, search: $search, type: ${internalValue.vamJobOfferType}`
          "
        />

        <DataInput
          v-if="internalValue.vamExport"
          v-model="internalValue.vamEducationAuthorization"
          type="bool"
          class="w-full md:w-1/3 md:mt-4 p-3"
          label="Ausbildungsberechtigung vorhanden"
          name="vamEducationAuthorization"
          :disabled="vamEducationAuthorizationRequired"
        />

        <DataInput
          v-if="internalValue.vamExport"
          v-model="internalValue.vamSocialInsurance"
          type="bool"
          class="w-full md:w-1/3 md:mt-4 p-3"
          label="Stellenangebot Sozialversicherungspflichtig"
          name="vamSocialInsurance"
          :disabled="vamSocialInsuranceRequired"
        />
        <div
          v-if="internalValue.vamExport && internalValue.vamExportError"
          class="w-full md:mt-4 p-3"
          style="color: red"
        >
          {{ getVamExportError[0] }}
          <div v-if="getVamExportError[1]">
            {{ getVamExportError[1] }}
          </div>
          <div v-if="vamErrorAutoResolveable()">
            Es wird versucht, die Fehler automatisch zu beheben.
          </div>
        </div>
      </div>
      <div id="jobContactPartner" class="flex flex-wrap flex-row">
        <h4 class="w-full mt-4 md:mt-12 p-3">Ansprechpartner</h4>
        <div class="px-2 w-full md:w-1/2 lg:w-1/4">
          <DataInput
            v-model="internalValue.contactType"
            type="select"
            :options="{
              CONSULTANT: 'Nutzer',
              USER_GROUP: 'Gruppe',
              OTHER: 'Andere'
            }"
            name="contactType"
            label="Art"
            required
          />
        </div>
        <div
          v-if="internalValue.contactType === 'CONSULTANT'"
          class="px-2 w-full md:w-1/2 lg:w-1/4"
        >
          <DataInput
            v-model="internalValue.contactID"
            type="model"
            name="contactConsultantId"
            label="Ansprechpartner (Berater)"
            model-label="
            firstName
            lastName"
            :select-label="el => el.firstName + ' ' + el.lastName"
            gql-query="consultantsPage"
            gql-single-query="consultant"
            gql-filter-type="objectFilter"
            required
          />
        </div>
        <div
          v-else-if="internalValue.contactType === 'USER_GROUP'"
          class="px-2 w-full md:w-1/2 lg:w-1/4"
        >
          <DataInput
            v-model="internalValue.contactID"
            type="model"
            name="contactGroupId"
            label="Ansprechpartner (Nutzergruppe)"
            gql-query="userGroups"
            required
          />
        </div>
        <div class="px-2 w-full lg:w-1/2">
          <DataInput
            v-model="internalValue.contactEmail"
            type="text"
            name="contactEmail"
            label="Ansprechpartner Email"
            :readonly="internalValue.contactType !== 'OTHER'"
            required
          />
        </div>
      </div>
      <div id="jobBeschreibung" class="flex flex-wrap flex-row">
        <h4 class="w-full mt-4 md:mt-12 p-3">Stellen Beschreibung</h4>

        <DataInput
          v-model="internalValue.internalInfo"
          type="html"
          label="Interne Informationen"
          class="w-full md:mt-4 p-3"
          name="internalInfo"
        />

        <DataInput
          v-model="internalValue.jobInfosText"
          type="html"
          class="w-full p-3"
          name="jobInfosText"
          label="Infos"
        />

        <TextTemplateChooser
          label="Firmen Profil (Einstieg)"
          type="COMPANY_DESCRIPTION"
          class="w-full md:mt-4 p-3"
          @textChoosen="v => (internalValue.companyProfileText = v)"
        />
        <DataInput
          v-model="internalValue.companyProfileHeading"
          :default="TextTemplateTypes.COMPANY_DESCRIPTION"
          class="w-full p-3"
          name="companyProfileHeading"
          disabled
        />
        <DataInput
          v-model="internalValue.companyProfileText"
          type="html"
          class="w-full p-3"
          name="companyProfileText"
        />

        <TextTemplateChooser
          label="Kundenbeschreibung"
          type="CUSTOMER_DESCRIPTION"
          class="w-full md:mt-4 p-3"
          @textChoosen="v => (internalValue.jobCustomerDetailsText = v)"
        />
        <DataInput
          v-model="internalValue.jobCustomerDetailsHeading"
          :default="TextTemplateTypes.CUSTOMER_DESCRIPTION"
          class="w-full p-3"
          name="jobCustomerDetailsHeading"
          disabled
        />
        <DataInput
          v-model="internalValue.jobCustomerDetailsText"
          type="html"
          class="w-full p-3"
          name="jobCustomerDetailsText"
        />

        <TextTemplateChooser
          label="Tätigkeit"
          type="ACTIVITIES"
          class="w-full md:mt-4 p-3"
          @textChoosen="v => (internalValue.jobActivitiesText = v)"
        />
        <DataInput
          v-model="internalValue.jobActivitiesHeading"
          :default="TextTemplateTypes.ACTIVITIES"
          class="w-full p-3"
          name="jobActivitiesHeading"
          disabled
        />
        <DataInput
          v-model="internalValue.jobActivitiesText"
          type="html"
          class="w-full p-3"
          name="jobActivitiesText"
        />

        <TextTemplateChooser
          label="Profil"
          type="PROFILE"
          class="w-full md:mt-4 p-3"
          @textChoosen="v => (internalValue.jobProfilesText = v)"
        />
        <DataInput
          v-model="internalValue.jobProfilesHeading"
          :default="TextTemplateTypes.PROFILE"
          class="w-full p-3"
          name="jobProfilesHeading"
          disabled
        />
        <DataInput
          v-model="internalValue.jobProfilesText"
          type="html"
          class="w-full p-3"
          name="jobProfilesText"
        />

        <TextTemplateChooser
          label="Perspektiven"
          type="PERSPECTIVES"
          class="w-full md:mt-4 p-3"
          @textChoosen="v => (internalValue.jobPerspectiveText = v)"
        />
        <DataInput
          v-model="internalValue.jobPerspectiveHeading"
          :default="TextTemplateTypes.PERSPECTIVES"
          class="w-full p-3"
          name="jobPerspectiveHeading"
          disabled
        />
        <DataInput
          v-model="internalValue.jobPerspectiveText"
          type="html"
          class="w-full p-3"
          name="jobPerspectiveText"
        />

        <TextTemplateChooser
          label="Abbinder"
          type="FOOTER"
          class="w-full md:mt-4 p-3"
          @textChoosen="v => (internalValue.jobFooterText = v)"
        />
        <DataInput
          v-model="internalValue.jobFooterHeading"
          :default="TextTemplateTypes.FOOTER"
          class="w-full p-3"
          name="jobFooterHeading"
          disabled
        />
        <DataInput
          v-model="internalValue.jobFooterText"
          type="html"
          class="w-full p-3"
          name="jobPerspectiveText"
        />
      </div>
      <div class="flex flex-wrap flex-row">
        <DataInput
          v-model="internalValue.companyLogoID"
          :value="internalValue.companyLogoID"
          type="image"
          class="mb-5 md:w-1/2 p-3"
          label="Firmen Logo"
          name="companyLogoID"
          public-file
        />
      </div>
    </div>
  </div>
</template>

<script>
import DataInput from "@/components/ui/DataInput";
import BAJobOfferType from "@/data/enums/BAJobOfferType.js";
import TextTemplateChooser from "./TextTemplateChooser";
import TextTemplateTypes from "@/data/enums/TextTemplateTypes";
import gql from "graphql-tag";
import * as moment from "moment";

const vacancyTemplateTypeQuery = gql`
  query VacancyTemplateType($id: ID!) {
    vacancyTemplateType(id: $id) {
      id
      name
      jobActivitiesText
      jobProfilesText
      jobPerspectiveText
      jobInfosText
      jobCustomerDetailsText
      jobFooterText
      jobActivitiesHeading
      jobProfilesHeading
      jobPerspectiveHeading
      jobInfosHeading
      jobCustomerDetailsHeading
      jobFooterHeading
      companyProfileText
      companyProfileHeading
    }
  }
`;

const consultantQuery = gql`
  query Consultant($id: ID!) {
    consultant(id: $id) {
      id
      user {
        id
        email
      }
    }
  }
`;

const userGroupQuery = gql`
  query UserGroup($id: ID!) {
    userGroup(id: $id) {
      id
      email
    }
  }
`;

export default {
  components: {
    DataInput,
    TextTemplateChooser
  },
  props: {
    value: { type: Object, required: true },
    projectConsultantID: { type: String, required: false }
  },
  data: () => ({
    republish: false,
    jobVariants: null,
    BAJobOfferType,
    vamSocialInsuranceRequired: false,
    vamEducationAuthorizationRequired: false,
    vamTitleError: false,
    TextTemplateTypes,
    templateIdUpdate: false,
    initialLoad: true,
    reloadBlocked: false
  }),
  computed: {
    getVamExportError() {
      let result = [this.internalValue.vamExportError];
      if (result[0].includes("FLR_JCValid_164")) {
        result.push(
          "Der Ausgewählte beruf steht Seitens der Arbeitsagentur nicht mehr zur verfügung." +
            " Bitte wählen Sie einen anderen Beruf aus."
        );
      }
      return result;
    },
    internalValue: {
      get() {
        console.log("here");
        return this.value;
      },
      set(val) {
        console.log("here2");
        this.$emit("input", val);
      }
    },
    activeFromEditable() {
      return (
        !this.internalValue.id ||
        !this.internalValue.activeFrom ||
        moment(this.internalValue.activeFrom).isAfter(moment())
      );
    }
  },
  apollo: {
    me: {
      query: gql`
        query Me {
          me {
            id
            consultant {
              id
            }
            group {
              id
            }
          }
        }
      `
    }
  },
  watch: {
    internalValue: {
      deep: true,
      handler: function(v) {
        this.internalValue = v;
        if (this.internalValue.publication) {
          this.republish = true;
        } else {
          this.republish = false;
        }
      }
    },
    republish(val) {
      if (!this.internalValue.publication && val) {
        this.$set(this.internalValue, "publication", {
          rePublishUntil: null,
          rePublishAmount: 4,
          rePublishInterval: 14
        });
      } else if (!val) {
        this.internalValue.publication = null;
      }
    },
    me(value) {
      if (value) {
        this.updateContactType(this.internalValue.contactType);
        this.initialLoad = false;
      }
    },
    "internalValue.vamJobOfferType": {
      immediate: true,
      handler(v) {
        if (v == 4) {
          // Ausbildungsplatz
          this.vamEducationAuthorizationRequired = true;
          this.internalValue.vamEducationAuthorization = true;
        } else {
          this.vamEducationAuthorizationRequired = false;
        }

        // When job is a "Minijobs" vamSocialInsurance can also be deactivated
        if (v == 1 || v == 4) {
          // Arbeitsplatz, Ausbildungsplatz
          this.vamSocialInsuranceRequired = true;
          this.internalValue.vamSocialInsurance = true;
        } else {
          this.vamSocialInsuranceRequired = false;
        }
      }
    },
    "internalValue.jobTemplateID": {
      immediate: true,
      handler(v) {
        if (!v) {
          this.templateIdUpdated = true;
          return;
        }
        this.$apollo
          .query({
            query: vacancyTemplateTypeQuery,
            variables: {
              id: v
            }
          })
          .then(value => {
            if (!this.reloadBlocked) {
              if (!this.templateIdUpdated) {
                value = value.data.vacancyTemplateType;
                this.internalValue.jobFooterHeading = value.jobFooterHeading;
                this.internalValue.jobPerspectiveHeading =
                  value.jobPerspectiveHeading;
                this.internalValue.jobProfilesHeading =
                  value.jobProfilesHeading;
                this.internalValue.jobActivitiesHeading =
                  value.jobActivitiesHeading;
                this.internalValue.jobCustomerDetailsHeading =
                  value.jobCustomerDetailsHeading;
                this.internalValue.companyProfileHeading =
                  value.companyProfileHeading;
                this.templateIdUpdated = true;
                return;
              }
              let template = value.data.vacancyTemplateType;
              delete template.name;
              delete template.id;
              this.internalValue = Object.assign(this.internalValue, template);
            }
          });
      }
    },
    "internalValue.contactID": {
      immidiate: true,
      handler() {
        this.updateContactEmail();
      }
    },
    "internalValue.contactType": {
      immidiate: true,
      handler(value) {
        if (!value && !this.initialLoad) {
          this.internalValue.contactID = "";
          this.internalValue.contactEmail = "";
        }
        this.updateContactType(value);
      }
    },
    "$route.params.jobid"() {
      console.log("here");
      this.reloadBlocked = true;
      setTimeout(() => (this.reloadBlocked = false), 1000);
    }
  },
  mounted() {
    if (!this.internalValue.contactType) {
      this.internalValue.contactType = "CONSULTANT";
    }
  },
  methods: {
    updateContactType(value) {
      if (
        value == "CONSULTANT" &&
        this.projectConsultantID &&
        (!this.internalValue.contactID || !this.initialLoad)
      ) {
        this.internalValue.contactID = this.projectConsultantID;
      } else if (
        value == "CONSULTANT" &&
        this.me &&
        (!this.internalValue.contactID || !this.initialLoad)
      ) {
        this.internalValue.contactID = this.me.consultant.id;
      } else if (
        value == "USER_GROUP" &&
        this.me &&
        (!this.internalValue.contactID || !this.initialLoad)
      ) {
        this.internalValue.contactID = this.me.group.id;
      } else if (!this.initialLoad) {
        this.internalValue.contactID = "";
      }
      this.updateContactEmail();
    },
    async updateContactEmail() {
      switch (this.internalValue.contactType) {
        case "CONSULTANT":
          if (this.internalValue.contactID) {
            try {
              const contact = (
                await this.$apollo.query({
                  query: consultantQuery,
                  variables: {
                    id: this.internalValue.contactID
                  }
                })
              ).data.consultant;
              this.internalValue.contactEmail = contact.user.email;
            } catch (e) {
              this.internalValue.contactEmail = "";
            }
          } else if (!this.initialLoad) {
            this.internalValue.contactEmail = "";
            return;
          }
          break;
        case "USER_GROUP":
          if (this.internalValue.contactID) {
            try {
              const contact = (
                await this.$apollo.query({
                  query: userGroupQuery,
                  variables: {
                    id: this.internalValue.contactID
                  }
                })
              ).data.userGroup;
              this.internalValue.contactEmail = contact.email;
            } catch (e) {
              this.internalValue.contactEmail = "";
            }
          } else if (!this.initialLoad) {
            this.internalValue.contactEmail = "";
            return;
          }
          break;

        default:
          this.internalValue.contactEmail =
            this.internalValue.contactEmail || "";
          this.internalValue.contactID = null;
          return;
      }
    },
    vamErrorAutoResolveable() {
      let autoResolvable = [
        "FLR_DataStore_120",
        "FLR_DataStore_130",
        "FLR_DataStore_139",
        "FLR_DataStore_186",
        "FLR_DataStore_110",
        "FLR_JCValid_216"
      ];

      for (let error of autoResolvable) {
        if (this.internalValue.vamExportError.includes(error)) {
          return true;
        }
      }

      return false;
    },
    setVamTitle() {
      if (
        this.internalValue.vamExport &&
        this.internalValue.title.length <= 54 &&
        this.internalValue.vamTitle == null
      ) {
        this.internalValue.vamTitle = this.internalValue.title;
      } else if (
        this.internalValue.vamExport &&
        this.internalValue.title.length >= 54
      ) {
        this.vamTitleError = true;
      }
    },
    checkVamTitle() {
      if (this.internalValue.vamTitle.length <= 54) {
        this.vamTitleError = false;
      }
    }
  }
};
</script>
